import type { SerializableRecord } from '../model';
import { transformContentfulSys } from './transformContentfulSys';
import { isSerializableRecord } from './isSerializableRecord';

export function transformInternalAnchorReference(
  value: SerializableRecord
): SerializableRecord | undefined {
  const sys = transformContentfulSys(value.sys);
  const fields = isSerializableRecord(value.fields) ? value.fields : undefined;

  if (!sys || !fields) {
    return undefined;
  }

  return {
    sys,
    fields: {
      id: fields.id
    }
  };
}
